import { UpdateSelectedLanguage } from "./localization.js";
import { InitializeScene } from "./scene/scene-3d.js";
import { InitializeCustomElements } from "./ui/custom-elements.js";
import { InitializeGenericUI } from "./ui/generic-ui.js";

InitializeScene();
InitializeCustomElements();
InitializeGenericUI();
UpdateSelectedLanguage(true);
